export default __webpack_public_path__ + "fonts/CabinetGrotesk-Medium.woff";